import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filterData: null, 
};

const filterSlice = createSlice({
  name: "newFilters",
  initialState,
  reducers: {
    setNewFiltersData: (state, action) => {
      state.filterData = action.payload; 
      state.expirationTime = Date.now() + 30 * 60 * 1000; // Expira em 30 minutos
    },
    clearNewFiltersData: (state) => {
      state.filterData = null; 
      state.expirationTime = null;
    },
  },
});

export const { setNewFiltersData, clearNewFiltersData } = filterSlice.actions; 
export default filterSlice.reducer; 
